// SHAR-614 — the details of a quote that differ from the customer's request,
// as the API marks them (`alternatives` on each quote row). The customer's app
// highlights the same details ("Alternative aircraft", "Alternative arrival
// airport", ...), so the admin sees, on the request, what the customer will be
// told is different.
import type { QuoteAlternatives } from '../api/types';

/** One label per differing detail, in the order the quote screen shows them. */
const LABELS: [keyof Omit<QuoteAlternatives, 'any' | 'route'>, string][] = [
  ['aircraft', 'Aircraft'],
  ['operator', 'Operator'],
  ['origin', 'Departure airport'],
  ['destination', 'Arrival airport'],
  ['departure', 'Departure time'],
  ['duration', 'Flight time'],
  ['arrival', 'Arrival time'],
];

/**
 * The labels of the details that differ. Empty when nothing differs, and also
 * when the API predates SHAR-614 and sends no `alternatives` (nothing is
 * claimed that the server did not say).
 */
export function alternativeLabels(a: QuoteAlternatives | null | undefined): string[] {
  if (!a) return [];
  return LABELS.filter(([k]) => a[k]).map(([, label]) => label);
}
